<template lang="pug">
div
  slot(name="activator" :openSheet="openSheet")
  Sheet(:showSheet="showSheet" @changeVisibility="handleVisibilityChange")
    template(v-if="showSheet")
      EventForm(@completed="closeSheet", :teardownTrigger="teardownTrigger" :isEdit="isEdit" :scrollTo="scrollTo")
</template>
<script lang="ts">
import Sheet from "components/UI/Sheet.vue"
import EventForm from "components/EventForm/EventForm.vue"
import { defineComponent } from "vue"

const EventSheetButton = defineComponent({
  name: "EventSheetButton",
  components: { EventForm, Sheet },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    scrollTo: { type: String, default: "" },
  },
  data: () => ({
    showSheet: false,
    teardownTrigger: false,
  }),
  methods: {
    openSheet() {
      this.handleVisibilityChange(true)
    },
    closeSheet() {
      this.handleVisibilityChange(false)
    },
    handleVisibilityChange(newVisibility: boolean) {
      this.showSheet = newVisibility
      if (newVisibility == false) {
        this.teardownTrigger = !this.teardownTrigger
      }
    },
  },
})

type EventSheetButtonType = InstanceType<typeof EventSheetButton>
export { EventSheetButtonType }
export default EventSheetButton
</script>
